import axiosClient from './axiosClient';

const adminStaffService = {
    // Oversight of Vendor Staff
    getAllVendorStaff: async (params) => {
        const response = await axiosClient.get('/admin/staffs', { params });
        return response.data;
    },
    updateVendorStaffStatus: async (id, status) => {
        const response = await axiosClient.patch(`/admin/staffs/${id}/status`, { status });
        return response.data;
    },
    deleteVendorStaff: async (id) => {
        const response = await axiosClient.delete(`/admin/staffs/${id}`);
        return response.data;
    },
    updateVendorStaff: async (id, payload) => {
        const response = await axiosClient.put(`/admin/staffs/${id}`, payload);
        return response.data;
    },

    // Management of Platform Employees (Admins)
    getAllAdmins: async (params) => {
        const response = await axiosClient.get('/admin/admins', { params });
        return response.data;
    },
    createAdmin: async (payload) => {
        const response = await axiosClient.post('/admin/admins', payload);
        return response.data;
    },
    updateAdmin: async (id, payload) => {
        const response = await axiosClient.put(`/admin/admins/${id}`, payload);
        return response.data;
    },
    deleteAdmin: async (id) => {
        const response = await axiosClient.delete(`/admin/admins/${id}`);
        return response.data;
    },
    updateAdminStatus: async (id, status) => {
        const response = await axiosClient.put(`/admin/admins/${id}/status`, { status });
        return response.data;
    }
};

export default adminStaffService;
